export default __webpack_public_path__ + "static/media/about_us_4.62e4a8b3.jpeg";